import React, { useState, useEffect, Fragment } from 'react';
import { Row, Card, CardBody } from 'reactstrap';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import { AxiosAPI } from '../../../../../helpers/AxiosAPI';
import {
  gAPI_RatePlans_List,
  gAPI_AddOns_List,
  gAPI_Promos_List,
  gAPI_Rooms_List,
} from '../../../../../constants/APIs';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import CreateRatePlansForm from './components/forms/CreateRatePlansForm';
import UpdateRatePlansForm from './components/forms/UpdateRatePlansForm';
import LinkRoomForm from './components/forms/LinkRoomForm';

function Index({ propertyId, locale }) {
  const [ratePlanList, setRatePlanList] = useState([]);
  const [
    applicableAddOnsWithIdAndName,
    setApplicableAddOnsWithIdAndName,
  ] = useState([]);
  const [
    includedAddOnsWithIdAndName,
    setIncludedAddOnsWithIdAndName,
  ] = useState([]);
  const [
    applicablePromosWithIdAndName,
    setApplicablePromosWithIdAndName,
  ] = useState([]);
  const [linkRoomList, setLinkRoomList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    AxiosAPI({
      methhod: 'get',
      url: `${gAPI_RatePlans_List}/?propertyId=${propertyId}&status=all&languageCode=${locale}`,
    })
      .then(res => {
        setRatePlanList(res.data.ratePlans);
        setLoading(false);
      })
      .catch(err => console.log('err', err));
  }, [propertyId]);

  useEffect(() => {
    AxiosAPI({
      methhod: 'get',
      url: `${gAPI_AddOns_List}/?propertyId=${propertyId}&status=all&languageCode=${locale}`,
    })
      .then(res => {
        setApplicableAddOnsWithIdAndName(
          res.data.addOns.map(plan => ({
            id: plan.id,
            name: plan.name,
            checked: false,
          }))
        );
        setIncludedAddOnsWithIdAndName(
          res.data.addOns.map(plan => ({
            id: plan.id,
            name: plan.name,
            checked: false,
          }))
        );
      })
      .catch(err => console.log('err', err));
  }, [propertyId]);

  useEffect(() => {
    AxiosAPI({
      methhod: 'get',
      url: `${gAPI_Promos_List}/?propertyId=${propertyId}&status=all&languageCode=${locale}`,
    })
      .then(res => {
        setApplicablePromosWithIdAndName(
          res.data.promos.map(prom => ({
            id: prom.id,
            name: prom.name,
            checked: false,
          }))
        );
      })
      .catch(err => console.log('err', err));
  }, [propertyId]);

  useEffect(() => {
    AxiosAPI({
      methhod: 'get',
      url: `${gAPI_Rooms_List}/?propertyId=${propertyId}`,
    })
      .then(res => {
        setLinkRoomList(
          res.data.rooms.map(room => ({
            id: room.id,
            name: room.name,
            checked: false,
          }))
        );
      })
      .catch(err => console.log('err', err));
  }, [propertyId]);

  if (loading) {
    return (
      <Card className="d-flex flex-row mb-3">
        <CardBody>
          <h4 style={{ textAlign: 'center' }}>Loading...</h4>
        </CardBody>
      </Card>
    );
  }

  return (
    <Fragment>
      <Row>
        {ratePlanList.map((ratePlan, index) => (
          <Colxx xxs="12" key={index}>
            <Card className="d-flex flex-row mb-3">
              <div className="pl-2 d-flex flex-grow-1 min-width-zero">
                <div className="card-body align-self-center d-flex flex-column flex-lg-row justify-content-between min-width-zero align-items-lg-center">
                  <p className="mb-1  text-small w-15 w-sm-100">
                    <b>{ratePlan.name}</b>
                  </p>
                  <p className="mb-1 text-muted text-small w-15 w-sm-100">
                    {ratePlan.discribtion}
                  </p>
                  <div className="w-15 w-sm-100">
                    <LinkRoomForm
                      id={ratePlan.id}
                      linkRoomList={linkRoomList}
                    />
                  </div>
                  <div className="w-15 w-sm-100">
                    <UpdateRatePlansForm
                      id={ratePlan.id}
                      applicableAddOnsWithIdAndName={
                        applicableAddOnsWithIdAndName
                      }
                      includedAddOnsWithIdAndName={includedAddOnsWithIdAndName}
                      applicablePromosWithIdAndName={
                        applicablePromosWithIdAndName
                      }
                    />
                  </div>
                </div>
              </div>
            </Card>
          </Colxx>
        ))}
      </Row>

      <CreateRatePlansForm />
    </Fragment>
  );
}

const mapStateToProps = ({ settings }) => {
  const { propertyId, locale } = settings;
  return {
    propertyId, locale
  };
};

export default injectIntl(connect(mapStateToProps, {})(Index));
